<template>
  <PlaceholderPantalla
    titulo="Entradas de Inventario"
    subtitulo="Registro de compras y recepciones de mercancía"
    descripcion="Registra todas las entradas de inventario cuando recibes mercancía de proveedores. El sistema actualiza automáticamente los stocks, calcula promedios de precios, vincula con órdenes de compra, y genera el movimiento contable correspondiente en el módulo de Finanzas."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Registrar entrada de inventario con múltiples productos',
  'Seleccionar proveedor del catálogo',
  'Ingresar cantidades recibidas y verificar contra orden de compra',
  'Registrar precio de compra por producto',
  'Actualización automática de stock en almacén',
  'Recálculo automático de precio promedio ponderado',
  'Vincular con factura del proveedor',
  'Adjuntar remisión o nota de entrega',
  'Inspección de calidad (aprobar/rechazar productos)',
  'Registrar diferencias entre lo pedido y lo recibido',
  'Asignar lote y fecha de caducidad',
  'Generar automáticamente cuenta por pagar en Finanzas',
  'Historial completo de entradas',
  'Reportes de compras por período',
  'Exportar entradas a Excel/PDF'
]

const datosManejados = [
  'Fecha y hora de la entrada',
  'Proveedor',
  'Número de factura/remisión',
  'Orden de compra relacionada (si existe)',
  'Lista de productos recibidos',
  'Cantidad por producto',
  'Unidad de medida',
  'Precio unitario de compra',
  'Subtotal, impuestos, total',
  'Lote y número de serie',
  'Fecha de caducidad',
  'Ubicación de almacenamiento',
  'Estado de inspección (aprobado/rechazado)',
  'Usuario que registró la entrada',
  'Comprobantes adjuntos',
  'Notas y observaciones',
  'Cuenta por pagar generada'
]
</script>
